const routes = [
  {
    path: '/workgroup',
    name: 'workgroup',
    component: () => import('@src/modules/workGroup/main'),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: 'index',
        name: 'workgroupIndex',
        component: () => import('@src/modules/workGroup/view/WorkGroup'),
        meta: {
          requireAuth: true,
          routerAlive: true
        },
      },
    ],
  },
]

export default routes
